// KPIs › My numbers (MEMBER-ENTRY, founder-approved 2026-10-21; spec 13 §Screens #11–12): the
// member's own entry screen and (UX-A, ux pass 1.3) its own seats' scorecard as the page's second
// tab (`?tab=scorecard`). `/kpis/my-scorecard` redirects there (replace, query kept). They are
// the KPIs routes open to a plain member (`ModeGate open`); every other scorecard screen stays
// company#reader's. `kpi`-gated by the mode like the rest of the scorecard.
import { createRoute, redirect, useNavigate } from "@tanstack/react-router";
import {
  MY_NUMBERS_TABS,
  MyNumbersPage,
  type MyNumbersTab,
} from "../features/numbers/my-numbers-page";
import { useCompany } from "../features/use-feature";
import { validateFocusSearch } from "../focus/focus";
import { ModeGate } from "../shell/mode-gate";
import { kpisRoute } from "./c.$slug.kpis";

export const myNumbersRoute = createRoute({
  getParentRoute: () => kpisRoute,
  path: "my-numbers",
  validateSearch: (search: Record<string, unknown>) => ({
    ...validateFocusSearch(search),
    ...(search.tab === "scorecard" ? { tab: "scorecard" as const } : {}),
  }),
  component: function MyNumbers() {
    const { api } = myNumbersRoute.useRouteContext();
    const { tab } = myNumbersRoute.useSearch();
    const navigate = useNavigate();
    return (
      <ModeGate modeKey="cadence" open>
        <MyNumbersPage
          api={api}
          company={useCompany()}
          tab={tab && (MY_NUMBERS_TABS as readonly string[]).includes(tab) ? tab : "numbers"}
          onTab={(next: MyNumbersTab) =>
            void navigate({
              to: ".",
              search: (prev: Record<string, unknown>) => {
                const { tab: _drop, ...rest } = prev;
                return next === "numbers" ? rest : { ...rest, tab: next };
              },
            } as never)
          }
        />
      </ModeGate>
    );
  },
});

export const myScorecardRoute = createRoute({
  getParentRoute: () => kpisRoute,
  path: "my-scorecard",
  beforeLoad: ({ params, location }) => {
    throw redirect({
      to: "/c/$slug/kpis/my-numbers",
      params,
      search: { ...(location.search as Record<string, string>), tab: "scorecard" } as never,
      replace: true,
    });
  },
});
